import React from 'react'

const ReusableIcon = ({ title, color }) => {
    return (
        <div style={{ border: `2px solid ${color}`, borderRadius: '50%' }}>
            <div style={{ border: '2px solid #FFFF', borderRadius: '50%' }}>
                <div style={{ background: color, padding: '2px', fontSize: '13px', fontWeight: 'bolder', width: '32px', height: '32px', textAlign: 'center', alignContent: 'center', borderRadius: '50%' }}>
                    {title.slice(0, 3).toUpperCase()}
                </div>
            </div>
        </div>
    )
}

export default ReusableIcon